/** отметка дня: галочка или, у навыков из старой версии, любые часы */
export function isDone(skill, day) {
    return skill.done[day] === true || (skill.hours[day] ?? 0) > 0;
}
//# sourceMappingURL=done.js.map